/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { toastError } from "../../../utils/sysToast";
import InfoPopUp from "../../commonComponents/infoPopUp";
import {
  buyVoucherPrint,
  payBillPrint,
  otherPaymentPrint,
  internetPrint,
  electricityPrint,
  postpaidBillPrint,
  otherPaymentMultiPrint,
} from "../../../utils/printFroms";
import { ExportSheet } from "react-xlsx-sheet";
import XLSX from "xlsx";
import BulkElectricityRecharge from "./bulkElectricityRecharge";

class Payments extends Component {
  state = {
    data: {
      unitId: "",
      payDate: "",
      bills: [],
      amount: "",
      seviceId: "",
      discountType: "",
      discountAmount: "",
      internetType: "",
      notes: "",
      payMethod: "",
      billingType: "",
      dueDate: "",
      typeId: ""
    },

    Username: "",
    //allPayTypes: [],
    allPayMethods: [],
    allUnits: [],
    allInternetTypes: [],
    allUnitsOwner: [],
    //allInStockVouchers: [],
    allUnitUnpaidBills: [],
    //allUnitsOwnerSlava: [],
    //allUnitsOwnerMiniSlava: [],
    allInternetItems: [],
    allDiscountTypes: [
      { label: "None", value: "" },
      { label: "Amount", value: "Amount" },
      { label: "Percentage", value: "Percentage" },
    ],
    services: [],
    payDate: "",
    dates: [new Date(new Date().setDate(new Date().getDate() - 4)), new Date()],
    service: "",
    payMethod: "",
    unit: "",
    totalAmountToPay: "",
    otherServices: [],
    otherPaymentBills: [{ serviceId: "", amount: "", dueDate: "", notes: "" }],
    cancelNotes: "",
    inCancelMode: false,
    cancelTargetRow: null,
    cancelOtherAction: "Unpaid",

    addButtonIcon: "fa fa-plus",
    modalWidth: "50vw",
    contentHeader: "Payments",

    inEditMode: false,
    inModalMode: false,

    inModalModePay: false,
    inModalModeCharge: false,
    inModalModeInternet: false,
    inModalModeOtherPayment: false,

    dataUrl: "/api/data/GetPayments",
    deleteUrl: "/api/data/DeleteBillsPayment",

    editEntityId: 0,

    inBulkElectricityMode: false,
    xlsxHeaders: [],
    tableData: [],
    totalAmountSearch: "",
  };

  handlePrint(row) {
    if (row.SERVICE === "Electricity") {
      electricityPrint(
        row.ID,
        row.PAY_METOD,
        row.UNIT_NAME,
        row.FULL_NAME,
        row.ELEC_VOUC_TYPE,
        row.PAY_AMOUNT,
        "",
        row.PAY_DATE,
        row.SYS_USERNAME,
        row.KW_RATE,
        row.USD_AMOUNT,
        row.SEQ_NO || "",
        row.COMPOUND_NAME_EN || "",
        row.COMPOUND_NAME_AR || ""
      );
    } else if (row.SERVICE === "Internet") {
      internetPrint(
        row.ID,
        row.PAY_METOD,
        row.UNIT_NAME,
        row.FULL_NAME,
        row.ELEC_VOUC_TYPE,
        row.PAY_AMOUNT,
        "",
        row.PAY_DATE,
        row.SYS_USERNAME,
        row.KW_RATE,
        row.USD_AMOUNT,
        row.SEQ_NO || "",
        row.COMPOUND_NAME_EN || "",
        row.COMPOUND_NAME_AR || ""
      );
    } else if (row.SERVICE === "test") {
      payBillPrint(
        "", //apiResponse.data.respData.paidBills,
        row.PAY_AMOUNT, //apiResponse.data.respData.totalAmount,
        row.SYS_USERNAME,
        row.DISCOUNT_TYPE,
        row.DISCOUNT_AMOUNT,
        row.PAY_AMOUNT //apiResponse.data.respData.paidAmount
      );
    } else if (row.SERVICE === "Service") {
      post(
        "/api/data/GetPrintBill",
        {
          id: row.ID,
        },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        if (apiResponse.data.respCode === 0) {
          payBillPrint(
            apiResponse.data.respData.paidBills,
            apiResponse.data.respData.totalAmount,
            apiResponse.data.respData.username,
            apiResponse.data.respData.discountType,
            apiResponse.data.respData.discountAmount,
            apiResponse.data.respData.paidAmount,
            apiResponse.data.respData.paymentSeqNo || "",
            apiResponse.data.respData.compoundNameEn || "",
            apiResponse.data.respData.compoundNameAr || ""
          );
        }
      });
    } else {
      post(
        "/api/data/GetPrintBill",
        { id: row.ID },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        if (apiResponse.data.respCode === 0) {
          const bills = apiResponse.data.respData.paidBills || [];
          if (bills.length > 0) {
            const first = bills[0];
            otherPaymentMultiPrint(
              apiResponse.data.respData.paymentSeqNo || "",
              apiResponse.data.respData.compoundNameEn || "",
              apiResponse.data.respData.compoundNameAr || "",
              first.UNIT_NAME || "",
              first.OWNER_NAME || "",
              first.SYS_USERNAME || "",
              false,
              first.METHOD_EN || "",
              first.PAY_DATE || "",
              bills.map(b => ({
                service: b.SERVICE_NAME || "",
                amount: b.DUE_AMOUNT || 0,
                seqNo: b.SEQ_NO || "",
                dueDate: b.DUE_DATE || "",
                notes: b.NOTES || "",
              })),
              apiResponse.data.respData.totalAmount || 0
            );
          }
        }
      });
    }
  }

  handleMoreInfo(row) {
    const jsonData = {
      "Total Amount Without Discount": row.PAY_AMOUNT_WITHOUT_DISCOUNT,
      "Discount Type": row.DISCOUNT_TYPE,
      "Discount Amount": row.DISCOUNT_AMOUNT,
      "Electricity Voucher Type": row.ELEC_VOUC_TYPE,
      "Electricity Voucher ID": row.ELEC_VOUC_ID,
      "Service Bill": row.SRVC_BILL_ID,
      "Gateway Response": row.GET_STATUS_RESP,
      "Electricity Type": row.UNIT_ELEC_TYPE,
      "Electricity Trans Status": row.ELEC_SYSTEM_TRANS_STATUS,
      "Electricity System Resp": row.ELEC_SYSTEM_RESP,
      Username: row.SYS_USERNAME,
      ...(row.IS_CANCELLED && {
        "Canceled By": row.CANCELED_BY,
        "Cancel Notes": row.CANCEL_NOTES,
      }),
    };

    confirmAlert({
      title: row.ID,
      childrenElement: () => (
        <InfoPopUp
          jsonData={jsonData}
          titlesColumnSize={4}
          valuesColumnSize={8}
          popUpWidth="500px"
        />
      ),
      buttons: [
        { label: this.props.t("btn.close"),
          onClick: () => {
            null;
          },
        },
      ],
    });
  }

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  showFormPayBill() {
    this.setState({ inModalModePay: true });
  }

  showFormOtherPayment() {
    this.setState({ inModalModeOtherPayment: true });
  }

  showFormCharge() {
    this.setState({ inModalModeCharge: true });
  }

  showFormInternet() {
    this.setState({ inModalModeInternet: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inModalModePay: false,
      inModalModeCharge: false,
      inModalModeInternet: false,
      inModalModeOtherPayment: false,
      allUnitUnpaidBills: [],
      otherPaymentBills: [{ serviceId: "", amount: "", dueDate: "", notes: "" }],
      data: data,
    });
  }

  componentDidMount() {
    //this.getAllPayTypes();
    this.getAllPayMethods();
    this.getAllUnits();
    this.getAllUnitsOwner();
    this.getOtherServices();
    //this.getAllUnitsOwnerSlava();
    //this.getAllUnitsOwnerMiniSlava();
    this.getAllServices();
    this.setState({
      Username: sysJwt.getUsername(),
    });
    this.getData();
  }

  //getAllPayTypes() {
  //  post("/api/data/GetAllPayType", null, this.props.updateIsLoading).then(
  //    (apiResponse) => {
  //      this.setState({
  //        allPayTypes: apiResponse.data.respData.data,
  //      });
  //    }
  //  );
  //}

  getAllServices() {
    post("/api/data/GetAllServices", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allServices: apiResponse.data.respData.data,
        });
      }
    );
  }

  getAllPayMethods() {
    post("/api/data/GetAllPayMethod", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allPayMethods: apiResponse.data.respData.data,
        });
      }
    );
  }

  getAllUnits() {
    post("/api/data/GetAllUnits", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allUnits: apiResponse.data.respData.data,
        });
      }
    );
  }

  getAllUnitsOwner() {
    post("/api/data/GetAllUnitsOwner", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          allUnitsOwner: apiResponse.data.respData.data,
        });
      }
    );
  }

  getAllInternetTypes(unitId) {
    post(
      "/api/data/GetInternetTypes",
      { unitId },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allInternetTypes: apiResponse.data.respData.data,
      });
    });
  }

  getOtherServices() {
    post("/api/data/GetOtherServices", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          otherServices: apiResponse.data.respData.data,
        });
      }
    );
  }

  getAllInternetItems(unitId) {
    post(
      "/api/data/GetAllElectrcityItems",
      { unitId },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allInternetItems: apiResponse.data.respData.data,
      });
    });
  }

  //getAllUnitsOwnerSlava() {
  //  post(
  //    "/api/data/GetAllUnitsOwnerSlava",
  //    null,
  //    this.props.updateIsLoading
  //  ).then((apiResponse) => {
  //    this.setState({
  //      allUnitsOwnerSlava: apiResponse.data.respData.data,
  //    });
  //  });
  //}

  //getAllUnitsOwnerMiniSlava() {
  //  post(
  //    "/api/data/GetAllUnitsOwnerMiniSlava",
  //    null,
  //    this.props.updateIsLoading
  //  ).then((apiResponse) => {
  //    this.setState({
  //      allUnitsOwnerMiniSlava: apiResponse.data.respData.data,
  //    });
  //  });
  //}

  //getAllInStockVouchers(unitId) {
  //  post(
  //    "/api/data/GetInStockVoucherTypes",
  //    { unitId: unitId },
  //    this.props.updateIsLoading
  //  ).then((apiResponse) => {
  //    this.setState({
  //      allInStockVouchers: apiResponse.data.respData.data,
  //    });
  //  });
  //}

  getUnitUnpaidBills(unitId) {
    this.setState({
        allUnitUnpaidBills: [],
      });
      this.updateForm("bills",[])
      if(unitId){
    post(
      "/api/data/GetUnitUnpaidBills",
      { unitId: unitId },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        allUnitUnpaidBills: apiResponse.data.respData.data,
      });
    });
  }
  }

  //doBuyVoucher() {
  //  post(
  //    "/api/data/BuyVoucherCash",
  //    {
  //      typeId: this.state.data.typeId,
  //      unitId: this.state.data.unitId,
  //    },
  //    this.props.updateIsLoading
  //  ).then((apiResponse) => {
  //    if (apiResponse.data.respCode === 0) {
  //      this.props.updateIsLoading(false);
  //      this.closeModal();
  //      buyVoucherPrint(
  //        apiResponse.data.respData.paymentId,
  //        apiResponse.data.respData.paymentMethod,
  //        apiResponse.data.respData.unitName,
  //        apiResponse.data.respData.ownerName,
  //        apiResponse.data.respData.voucherType,
  //        apiResponse.data.respData.price,
  //        apiResponse.data.respData.serialNumber,
  //        apiResponse.data.respData.payDate,
  //        apiResponse.data.respData.username
  //      );
  //    }
  //  });
  //}

  addOtherBillRow() {
    this.setState(prev => ({
      otherPaymentBills: [...prev.otherPaymentBills, { serviceId: "", amount: "", dueDate: "", notes: "" }],
    }));
  }

  removeOtherBillRow(index) {
    this.setState(prev => ({
      otherPaymentBills: prev.otherPaymentBills.filter((_, i) => i !== index),
    }));
  }

  updateOtherBillRow(index, field, value) {
    this.setState(prev => {
      const bills = [...prev.otherPaymentBills];
      bills[index] = { ...bills[index], [field]: value };
      return { otherPaymentBills: bills };
    });
  }

  getOtherBillsTotal() {
    return this.state.otherPaymentBills.reduce((sum, b) => sum + (parseFloat(b.amount) || 0), 0);
  }

  doOtherPayment() {
    if (!this.state.data.billingType) {
      toastError(this.props.t("validation.billingTypeRequired"));
      return;
    }
    if (!this.state.data.unitId) {
      toastError(this.props.t("col.unitName") + " " + this.props.t("validation.required"));
      return;
    }

    const validBills = this.state.otherPaymentBills.filter(b => b.serviceId && b.amount);
    if (validBills.length === 0) {
      toastError("Please add at least one bill with service and amount");
      return;
    }

    const isPostpaid = this.state.data.billingType === "Postpaid";

    if (isPostpaid && validBills.some(b => !b.dueDate)) {
      toastError("Due date is required for each bill in Postpaid mode");
      return;
    }

    if (!isPostpaid && !this.state.data.payMethod) {
      toastError(this.props.t("col.payMethod") + " " + this.props.t("validation.required"));
      return;
    }

    const endpoint = isPostpaid ? "/api/data/AddMultipleOtherServiceBills" : "/api/data/PayMultipleUnitByService";
    const payload = isPostpaid
      ? {
          unitId: this.state.data.unitId,
          bills: validBills.map(b => ({ serviceId: b.serviceId, amount: b.amount, dueDate: b.dueDate, notes: b.notes })),
        }
      : {
          unitId: this.state.data.unitId,
          payMethod: this.state.data.payMethod,
          bills: validBills.map(b => ({ serviceId: b.serviceId, amount: b.amount, notes: b.notes })),
        };

    post(endpoint, payload, this.props.updateIsLoading).then(apiResponse => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
        const items = apiResponse.data.respData.data || [];
        if (items.length > 0) {
          const first = items[0];
          otherPaymentMultiPrint(
            isPostpaid ? "" : (first.seqNo || ""),
            first.compoundNameEn || "",
            first.compoundNameAr || "",
            first.unitName || "",
            first.ownerName || "",
            first.username || "",
            isPostpaid,
            isPostpaid ? "" : (first.paymentMethod || ""),
            isPostpaid ? "" : (first.payDate || ""),
            items.map(item => ({
              service: isPostpaid ? item.serviceName : item.service,
              amount: isPostpaid ? item.dueAmount : item.price,
              seqNo: item.seqNo || "",
              dueDate: item.dueDate || "",
              notes: item.notes || "",
            })),
            items.reduce((sum, item) => sum + (isPostpaid ? (item.dueAmount || 0) : (item.price || 0)), 0)
          );
        }
      }
    });
  }

  doCharge() {
    if (!this.state.data.billingType) {
      toastError(this.props.t("validation.billingTypeRequired"));
      return;
    }
    const isPostpaid = this.state.data.billingType === "Postpaid";
    post(
      "/api/data/ChargeElectricity",
      {
        unitId: this.state.data.unitId,
        typeId: this.state.data.typeId,
        billingType: this.state.data.billingType,
        ...(isPostpaid
          ? { dueDate: this.state.data.dueDate }
          : { payMethod: this.state.data.payMethod }),
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
        if (isPostpaid) {
          postpaidBillPrint(
            apiResponse.data.respData.billId,
            apiResponse.data.respData.unitName,
            apiResponse.data.respData.ownerName,
            apiResponse.data.respData.serviceName,
            apiResponse.data.respData.dueDate,
            apiResponse.data.respData.dueAmount,
            apiResponse.data.respData.notes,
            apiResponse.data.respData.username,
            false,
            "",
            apiResponse.data.respData.seqNo || "",
            apiResponse.data.respData.compoundNameEn || "",
            apiResponse.data.respData.compoundNameAr || ""
          );
        } else {
          electricityPrint(
            apiResponse.data.respData.paymentId,
            apiResponse.data.respData.paymentMethod,
            apiResponse.data.respData.unitName,
            apiResponse.data.respData.ownerName,
            "",
            apiResponse.data.respData.price,
            "",
            apiResponse.data.respData.payDate,
            apiResponse.data.respData.username,
            apiResponse.data.respData.kwRate,
            apiResponse.data.respData.usdAmount,
            apiResponse.data.respData.seqNo || "",
            apiResponse.data.respData.compoundNameEn || "",
            apiResponse.data.respData.compoundNameAr || ""
          );
        }
      }
    });
  }

  doInternet() {
    post(
      "/api/data/ChargeInternet",
      {
        unitId: this.state.data.unitId,
        internetType: this.state.data.internetType,
        payMethod: this.state.data.payMethod,
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
        internetPrint(
          apiResponse.data.respData.paymentId,
          apiResponse.data.respData.paymentMethod,
          apiResponse.data.respData.unitName,
          apiResponse.data.respData.ownerName,
          "",
          apiResponse.data.respData.price,
          "",
          apiResponse.data.respData.payDate,
          apiResponse.data.respData.username,
          apiResponse.data.respData.kwRate,
          apiResponse.data.respData.usdAmount,
          apiResponse.data.respData.seqNo || "",
          apiResponse.data.respData.compoundNameEn || "",
          apiResponse.data.respData.compoundNameAr || ""
        );
      }
    });
  }

  doPayBills() {
    const billIds = (this.state.data.bills || []).map(String);
    if (billIds.length === 0) {
      toastError("Please select at least one bill");
      return;
    }
    /*const selectedItems = this.state.allUnitUnpaidBills.filter((b) =>
      billIds.includes(String(b.value))
    );
    const uniqueServices = [...new Set(selectedItems.map((b) => String(b.serviceId)))];
    if (uniqueServices.length > 1) {
      toastError(this.props.t("validation.billsSameService"));
      return;
    }*/

    const { discountType, discountAmount } = this.state.data;
    const total = this.state.totalAmountToPay;
    if (discountType && discountAmount) {
      const amount = parseFloat(discountAmount);
      if (discountType === "Amount" && amount > total) {
        toastError(this.props.t("validation.discountExceedsTotal"));
        return;
      }
      if (discountType === "Percentage" && amount > 100) {
        toastError(this.props.t("validation.discountExceeds100"));
        return;
      }
    }

    post(
      "/api/data/PayUnitBillsCash",
      {
        bills: this.state.data.bills,
        discountType: this.state.data.discountType,
        discountAmount: this.state.data.discountAmount,
        payMethod: this.state.data.payMethod,
      },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
        payBillPrint(
          apiResponse.data.respData.paidBills,
          apiResponse.data.respData.totalAmount,
          apiResponse.data.respData.username,
          apiResponse.data.respData.discountType,
          apiResponse.data.respData.discountAmount,
          apiResponse.data.respData.paidAmount,
          apiResponse.data.respData.paymentSeqNo || "",
          apiResponse.data.respData.compoundNameEn || "",
          apiResponse.data.respData.compoundNameAr || ""
        );
      }
    });
  }

  getData() {
    if (!this.state.dates[0] || !this.state.dates[1]) {
      toastError("Please select DateFrom and DateTo");
    } else {
      post(
        this.state.dataUrl,
        {
          dateFrom: this.state.dates[0],
          dateTo: this.state.dates[1],
          unitId: this.state.unit,
          serviceId: this.state.service,
          payMethod: this.state.payMethod,
        },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        this.setState({
          tableData: apiResponse.data.respData.data,
          totalAmountSearch: apiResponse.data.respData.totalAmount,
        });
        this.buildReportTable(apiResponse.data.respData.data);
      });
    }
  }

  buildReportTable(reportData) {
    let xlsxHeaders = [];
    let co = 1;
    if (reportData.length !== 0) {
      for (var property in reportData[0]) {
        if (reportData[0].hasOwnProperty(property)) {
          co++;
          xlsxHeaders.push({ title: property, dataIndex: property });
        }
      }
      this.setState({
        xlsxHeaders: xlsxHeaders,
      });
    }
  }

  sumTotalBills(bills) {
    if (!bills || bills.length === 0) {
      this.setState({ totalAmountToPay: 0 });
      this.updateForm("discountAmount", null);
      return;
    }
    const billIds = bills.map(String);
    const selectedItems = this.state.allUnitUnpaidBills.filter((b) =>
      billIds.includes(String(b.value))
    );
    const sum = selectedItems.reduce((acc, b) => acc + (b.dueAmount || 0), 0);
    // Clear discount if it now exceeds the new total
    const { discountType, discountAmount } = this.state.data;
    if (discountType === "Amount" && discountAmount && parseFloat(discountAmount) > sum) {
      this.updateForm("discountAmount", null);
    }
    this.setState({ totalAmountToPay: sum });
  }

  handleDelete(row) {
    this.setState({ inCancelMode: true, cancelTargetRow: row, cancelNotes: "", cancelOtherAction: "Unpaid" });
  }

  doCancel() {
    const row = this.state.cancelTargetRow;
    const payload = { PaymentId: row.ID, cancelNotes: this.state.cancelNotes };

    // Service bills always go back to unpaid. Bills this payment created itself are
    // only deleted when the user picked that explicitly.
    if (row.OTHER_BILLS_COUNT > 0) {
      payload.otherBillsAction = this.state.cancelOtherAction;
    }

    post(
      this.state.deleteUrl,
      payload,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.setState({ inCancelMode: false, cancelTargetRow: null, cancelNotes: "", cancelOtherAction: "Unpaid" });
        this.getData();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        field: "ID",
        label: t("col.id"),
        width: "75px",
      },
      {
        id: 2,
        label: t("col.payDate"),
        field: "PAY_DATE",
      },
      {
        id: 3,
        label: t("col.amount"),
        field: "PAY_AMOUNT",
      },
      {
        id: 4,
        label: t("col.service"),
        field: "SERVICE",
      },
      {
        id: 5,
        label: t("col.payMethod"),
        field: "PAY_METOD",
      },
      {
        id: 6,
        label: t("col.seqNo"),
        field: "SEQ_NO",
        width: "110px",
      },
      {
        id: 7,
        label: t("col.compound"),
        field: "COMPOUND_NAME_EN",
      },
      {
        id: 8,
        label: t("col.unit"),
        field: "UNIT_NAME",
      },
      {
        id: 9,
        label: t("col.owner"),
        field: "FULL_NAME",
      },
      {
        id: 10,
        label: t("col.discountType"),
        field: "DISCOUNT_TYPE",
      },
      {
        id: 11,
        label: t("col.discountAmount"),
        field: "DISCOUNT_AMOUNT",
      },
      {
        id: 12,
        label: t("col.username"),
        field: "SYS_USERNAME",
      },
      {
        id: 13,
        label: t("col.status"),
        field: "IS_CANCELLED",
        width: "200px",
        cellRenderer: ({ data }) => data.IS_CANCELLED
          ? (
            <span title={data.CANCEL_NOTES || ""} style={{ color: "#c0392b", fontWeight: "600", fontSize: "12px" }}>
              <i className="fa fa-ban" style={{ marginRight: "4px" }} />
              {t("col.cancelled")}
              {data.CANCEL_NOTES ? ` — ${data.CANCEL_NOTES}` : ""}
            </span>
          )
          : null,
      },
      {
        id: 14,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 15,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 16,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              <div className="inner" title="Payment Order Info">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.handleMoreInfo(data);
                  }}
                >
                  <i className="fa fa-info" />
                </button>
              </div>
              <div className="inner" title="Print">
                <button
                  className="dropdown-item btn-popup-menu"
                  disabled={this.props.isLoading}
                  onClick={() => {
                    this.handlePrint(data);
                  }}
                >
                  <i className="fa fa-print" />
                </button>
              </div>
              {sysJwt.isAuthorized(["CB70"]) &&
                !data.IS_CANCELLED &&
                !data.IS_APP_PAYMENT &&
                data.SERVICE !== "Electricity" &&
                data.SERVICE !== "Internet" && (
                <div className="inner" title="Cancel">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row align-items-center">
          <div className="col">
            <h4>{t("pages.payments")}</h4>
          </div>
          <div className="col-auto page-actions">
            {sysJwt.isAuthorized(["CB41"]) && (
              <Button
                label={t("btn.chargeElectricity")}
                icon="fa fa-bolt"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.showFormCharge()}
              />
            )}
            {sysJwt.isAuthorized(["CB94"]) && (
              <Button
                label={t("btn.bulkChargeElectricity")}
                icon="fa fa-bolt"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.setState({ inBulkElectricityMode: true })}
              />
            )}
            {sysJwt.isAuthorized(["CB68"]) && (
              <Button
                label={t("btn.chargeInternet")}
                icon="fa fa-wifi"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.showFormInternet()}
              />
            )}
            {sysJwt.isAuthorized(["CB34"]) && (
              <Button
                label={t("btn.payBill")}
                icon="fa fa-money"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.showFormPayBill()}
              />
            )}
            {sysJwt.isAuthorized(["CB42"]) && (
              <Button
                label={t("btn.otherPayment")}
                icon="fa fa-credit-card"
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.showFormOtherPayment()}
              />
            )}
          </div>
        </div>
        <div className="page-filter-bar">
          <span className="filter-label">{t("filter.date")}:</span>
          <Calendar
            selectionMode="range"
            showIcon
            value={this.state.dates}
            onChange={(e) => this.setState({ dates: e.value })}
          />
          <span className="filter-label">{t("filter.service")}:</span>
          <Dropdown
            value={this.state.service}
            showClear
            options={this.state.allServices}
            filter
            onChange={(e) => this.setState({ service: e.target.value })}
          />
          <span className="filter-label">{t("filter.payMethod")}:</span>
          <Dropdown
            value={this.state.payMethod}
            showClear
            options={this.state.allPayMethods}
            filter
            onChange={(e) => this.setState({ payMethod: e.target.value })}
          />
          <span className="filter-label">{t("filter.unit")}:</span>
          <Dropdown
            value={this.state.unit}
            showClear
            options={this.state.allUnits}
            filter
            onChange={(e) => this.setState({ unit: e.target.value })}
          />
          <Button
            label={t("btn.search")}
            icon="fa fa-search"
            className="p-button-rounded p-button-secondary"
            disabled={this.props.isLoading}
            onClick={() => this.getData()}
          />
        </div>
        <hr />

        {/* Cancel Payment Dialog */}
        <Dialog
          visible={this.state.inCancelMode}
          style={{ width: "40vw" }}
          onHide={() => this.setState({ inCancelMode: false, cancelTargetRow: null, cancelNotes: "", cancelOtherAction: "Unpaid" })}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("dialog.cancelPayment")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.confirm")}
                icon="fa fa-ban"
                className="p-button-rounded p-button-danger"
                disabled={this.props.isLoading}
                onClick={() => this.doCancel()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-secondary"
                onClick={() => this.setState({ inCancelMode: false, cancelTargetRow: null, cancelNotes: "", cancelOtherAction: "Unpaid" })}
              />
            </div>
          }
        >
          <div style={{ marginBottom: "8px", color: "black" }}>
            {t("dialog.cancelPaymentConfirm")} <b>#{this.state.cancelTargetRow?.ID}</b>
          </div>
          {this.state.cancelTargetRow?.OTHER_BILLS_COUNT > 0 && (
            <div style={{ marginBottom: "12px" }}>
              <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", color: "#555", fontSize: "13px" }}>
                {t("dialog.cancelOtherBillsQuestion")}{" "}
                <b>({this.state.cancelTargetRow?.OTHER_BILLS_COUNT})</b>
              </label>
              <Dropdown
                value={this.state.cancelOtherAction}
                options={[
                  { label: t("dialog.cancelOtherBillsUnpaid"), value: "Unpaid" },
                  { label: t("dialog.cancelOtherBillsDelete"), value: "Delete" },
                ]}
                onChange={(e) => this.setState({ cancelOtherAction: e.value })}
                style={{ width: "100%" }}
                disabled={this.props.isLoading}
              />
            </div>
          )}
          <label style={{ display: "block", marginBottom: "4px", fontWeight: "bold", color: "#555", fontSize: "13px" }}>
            {t("col.cancelReason")}
          </label>
          <InputText
            value={this.state.cancelNotes}
            onChange={(e) => this.setState({ cancelNotes: e.target.value })}
            style={{ width: "100%" }}
            placeholder={t("col.cancelReason")}
            disabled={this.props.isLoading}
          />
        </Dialog>
        {/*<Dialog*/}
        {/*  visible={this.state.inModalMode}*/}
        {/*  style={{ width: this.state.modalWidth }}*/}
        {/*  onHide={(e) => this.closeModal()}*/}
        {/*  dismissableMask={true}*/}
        {/*  closable={false}*/}
        {/*  header={<h5 className="modal-header">Buy Voucher Cash</h5>}*/}
        {/*  footer={*/}
        {/*    <div>*/}
        {/*      <Button*/}
        {/*        label={t("btn.save")}*/}
        {/*        icon={this.state.modalSubmitButtonIconAdd}*/}
        {/*        className="p-button-rounded p-button-secondary"*/}
        {/*        disabled={this.props.isLoading}*/}
        {/*        onClick={() => this.doBuyVoucher()}*/}
        {/*      />*/}
        {/*      <Button*/}
        {/*        label={t("btn.cancel")}*/}
        {/*        icon="fa fa-close"*/}
        {/*        className="p-button-rounded p-button-danger"*/}
        {/*        onClick={() => this.closeModal()}*/}
        {/*      />*/}
        {/*    </div>*/}
        {/*  }*/}
        {/*>*/}
        {/*  <SysForm*/}
        {/*    isLoading={this.props.isLoading}*/}
        {/*    inEditMode={this.state.inEditMode}*/}
        {/*    data={this.state.data}*/}
        {/*    updateForm={this.updateForm}*/}
        {/*    inputs={[*/}
        {/*      {*/}
        {/*        type: "dropdown",*/}
        {/*        id: "unitId",*/}
        {/*        label: "Unit Name",*/}
        {/*        disabled: false,*/}
        {/*        options: this.state.allUnitsOwnerSlava,*/}
        {/*        customOnChangeHandler: (unitId) => {*/}
        {/*          this.getAllInStockVouchers(unitId);*/}
        {/*        },*/}
        {/*      },*/}
        {/*      {*/}
        {/*        type: "dropdown",*/}
        {/*        id: "typeId",*/}
        {/*        label: "Voucher Tpye",*/}
        {/*        disabled: false,*/}
        {/*        options: this.state.allInStockVouchers,*/}
        {/*      },*/}
        {/*    ]}*/}
        {/*  />*/}
        {/*</Dialog>*/}
        <Dialog
          visible={this.state.inModalModeOtherPayment}
          style={{ width: "65vw" }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("btn.otherPayment")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon={this.state.modalSubmitButtonIconAdd}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doOtherPayment()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <div style={{ marginBottom: "12px" }}>
            <label style={{ fontWeight: "bold", marginRight: "16px", color: "black" }}>{t("col.billingType")}:</label>
            {sysJwt.isAuthorized(["CB92"]) && (
              <label style={{ marginRight: "12px", color: "black" }}>
                <input
                  type="radio"
                  name="billingType"
                  value="Prepaid"
                  checked={this.state.data.billingType === "Prepaid"}
                  onChange={() => this.updateForm("billingType", "Prepaid")}
                  style={{ marginRight: "4px" }}
                />
                {t("col.prepaidPayNow")}
              </label>
            )}
            {sysJwt.isAuthorized(["CB93"]) && (
              <label style={{ color: "black" }}>
                <input
                  type="radio"
                  name="billingType"
                  value="Postpaid"
                  checked={this.state.data.billingType === "Postpaid"}
                  onChange={() => this.updateForm("billingType", "Postpaid")}
                  style={{ marginRight: "4px" }}
                />
                {t("col.postpaidBillLater")}
              </label>
            )}
          </div>
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "unitId",
                label: t("col.unitName"),
                disabled: false,
                options: this.state.allUnitsOwner,
              },
              ...(this.state.data.billingType === "Prepaid"
                ? [{ type: "dropdown", id: "payMethod", label: t("col.payMethod"), disabled: false, options: this.state.allPayMethods }]
                : []),
            ]}
          />

          {/* Bills table */}
          <div style={{ marginTop: "12px" }}>
            <div style={{ display: "grid", gridTemplateColumns: this.state.data.billingType === "Postpaid" ? "2fr 1fr 1fr 2fr 36px" : "2fr 1fr 2fr 36px", gap: "6px", marginBottom: "4px" }}>
              <span style={{ fontWeight: "600", fontSize: "12px", color: "#555" }}>{t("col.service")}</span>
              <span style={{ fontWeight: "600", fontSize: "12px", color: "#555" }}>{t("col.paymentAmount")}</span>
              {this.state.data.billingType === "Postpaid" && (
                <span style={{ fontWeight: "600", fontSize: "12px", color: "#555" }}>{t("col.dueDate")}</span>
              )}
              <span style={{ fontWeight: "600", fontSize: "12px", color: "#555" }}>{t("col.notes")}</span>
              <span />
            </div>
            {this.state.otherPaymentBills.map((bill, index) => (
              <div key={index} style={{ display: "grid", gridTemplateColumns: this.state.data.billingType === "Postpaid" ? "2fr 1fr 1fr 2fr 36px" : "2fr 1fr 2fr 36px", gap: "6px", marginBottom: "6px", alignItems: "center" }}>
                <Dropdown
                  value={bill.serviceId}
                  options={this.state.otherServices}
                  onChange={(e) => this.updateOtherBillRow(index, "serviceId", e.value)}
                  placeholder={t("col.service")}
                  filter
                  disabled={this.props.isLoading}
                  style={{ width: "100%" }}
                />
                <InputText
                  value={bill.amount}
                  onChange={(e) => this.updateOtherBillRow(index, "amount", e.target.value)}
                  placeholder="0"
                  type="number"
                  disabled={this.props.isLoading}
                  style={{ width: "100%" }}
                />
                {this.state.data.billingType === "Postpaid" && (
                  <Calendar
                    value={bill.dueDate ? new Date(bill.dueDate) : null}
                    onChange={(e) => this.updateOtherBillRow(index, "dueDate", e.value)}
                    placeholder={t("col.dueDate")}
                    dateFormat="yy/mm/dd"
                    disabled={this.props.isLoading}
                    style={{ width: "100%" }}
                    inputStyle={{ width: "100%" }}
                  />
                )}
                <InputText
                  value={bill.notes}
                  onChange={(e) => this.updateOtherBillRow(index, "notes", e.target.value)}
                  placeholder={t("col.notes")}
                  disabled={this.props.isLoading}
                  style={{ width: "100%" }}
                />
                {this.state.otherPaymentBills.length > 1 ? (
                  <Button
                    icon="fa fa-trash"
                    className="p-button-rounded p-button-danger"
                    style={{ width: "32px", height: "32px" }}
                    disabled={this.props.isLoading}
                    onClick={() => this.removeOtherBillRow(index)}
                  />
                ) : <span />}
              </div>
            ))}
            <Button
              label={t("btn.add")}
              icon="fa fa-plus"
              className="p-button-rounded p-button-secondary"
              style={{ marginTop: "4px" }}
              disabled={this.props.isLoading}
              onClick={() => this.addOtherBillRow()}
            />
          </div>

          {/* Total */}
          <div style={{ marginTop: "14px", textAlign: "right", fontWeight: "bold", color: "black", fontSize: "15px" }}>
            {t("col.totalAmountToPay")}: {this.getOtherBillsTotal().toLocaleString()}
          </div>
        </Dialog>
        <Dialog
          visible={this.state.inModalModeCharge}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("btn.chargeElectricity")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon={this.state.modalSubmitButtonIconAdd}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doCharge()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <div style={{ marginBottom: "12px" }}>
            <label style={{ fontWeight: "bold", marginRight: "16px", color: "black" }}>{t("col.billingType")}:</label>
            <label style={{ marginRight: "12px", color: "black" }}>
              <input
                type="radio"
                name="elecBillingType"
                value="Prepaid"
                checked={this.state.data.billingType === "Prepaid"}
                onChange={() => this.updateForm("billingType", "Prepaid")}
                style={{ marginRight: "4px" }}
              />
              {t("col.prepaidPayNow")}
            </label>
            <label style={{ color: "black" }}>
              <input
                type="radio"
                name="elecBillingType"
                value="Postpaid"
                checked={this.state.data.billingType === "Postpaid"}
                onChange={() => this.updateForm("billingType", "Postpaid")}
                style={{ marginRight: "4px" }}
              />
              {t("col.postpaidBillLater")}
            </label>
          </div>
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "unitId",
                label: t("col.unitName"),
                disabled: false,
                options: this.state.allUnitsOwner,
                customOnChangeHandler: (unitId) => {
                  this.getAllInternetItems(unitId);
                },
              },
              {
                type: "dropdown",
                id: "typeId",
                label: t("col.electricityItem"),
                disabled: false,
                options: this.state.allInternetItems,
              },
              ...(this.state.data.billingType === "Postpaid"
                ? [
                    {
                      type: "datetime",
                      id: "dueDate",
                      label: t("col.dueDate"),
                      disabled: false,
                    },
                  ]
                : [
                    {
                      type: "dropdown",
                      id: "payMethod",
                      label: t("col.payMethod"),
                      disabled: false,
                      options: this.state.allPayMethods,
                    },
                  ]),
            ]}
          />
        </Dialog>
        <Dialog
          visible={this.state.inModalModeInternet}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("btn.chargeInternet")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon={this.state.modalSubmitButtonIconAdd}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doInternet()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "unitId",
                label: t("col.unitName"),
                disabled: false,
                options: this.state.allUnitsOwner,
                customOnChangeHandler: (unitId) => {
                  this.getAllInternetTypes(unitId);
                },
              },
              {
                type: "dropdown",
                id: "payMethod",
                label: t("col.payMethod"),
                disabled: false,
                options: this.state.allPayMethods,
              },
              {
                type: "dropdown",
                id: "internetType",
                label: t("col.internetType"),
                disabled: false,
                options: this.state.allInternetTypes,
              },
            ]}
          />
        </Dialog>
        <Dialog
          visible={this.state.inModalModePay}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={<h5 className="modal-header">{t("btn.payBill")}</h5>}
          footer={
            <div>
              <Button
                label={t("btn.save")}
                icon={this.state.modalSubmitButtonIconAdd}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doPayBills()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "dropdown",
                id: "unitId",
                label: t("col.unitName"),
                disabled: false,
                options: this.state.allUnitsOwner,
                customOnChangeHandler: (unitId) => {
                  this.getUnitUnpaidBills(unitId);
                },
              },
              {
                type: "dropdown",
                id: "discountType",
                label: t("col.discountType"),
                disabled: sysJwt.isAuthorized(["CB4F"]) ? false : true,
                options: this.state.allDiscountTypes,
                customOnChangeHandler: (val) => {
                  this.updateForm("discountAmount", null);
                },
              },
              {
                type: "multiselect",
                id: "bills",
                label: t("col.billsToPay"),
                disabled: false,
                options: this.state.allUnitUnpaidBills,
                customOnChangeHandler: (bills) => {
                  this.sumTotalBills(bills);
                },
              },
              {
                type: "text",
                id: "discountAmount",
                label: t("col.discountAmount"),
                disabled: !sysJwt.isAuthorized(["CB4F"]) || !this.state.data.discountType || !this.state.totalAmountToPay,
                maxValue: this.state.data.discountType === "Percentage"
                  ? 100
                  : this.state.totalAmountToPay,
              },
              {
                type: "dropdown",
                id: "payMethod",
                label: t("col.payMethod"),
                disabled: false,
                options: this.state.allPayMethods,
              },
            ]}
          />
          <span style={{ color: "black" }}>
            {t("col.totalAmountToPay")}: {this.state.totalAmountToPay}
          </span>
          <br />
          <span style={{ color: "black" }}>
            {t("col.netAmountToPay")}:{" "}
            {this.state.data.discountType && this.state.data.discountAmount
              ? this.state.data.discountType === "Amount"
                ? this.state.totalAmountToPay - this.state.data.discountAmount
                : this.state.totalAmountToPay -
                  (this.state.totalAmountToPay *
                    this.state.data.discountAmount) /
                    100
              : this.state.totalAmountToPay}
          </span>
        </Dialog>
        {this.state.inBulkElectricityMode && (
          <BulkElectricityRecharge
            visible={this.state.inBulkElectricityMode}
            isLoading={this.props.isLoading}
            updateIsLoading={this.props.updateIsLoading}
            onClose={() => this.setState({ inBulkElectricityMode: false })}
          />
        )}
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
        <div className="row">
          <div className="col-10">
            <span style={{ color: "black" }}>
              Total Amount: <b>{this.state.totalAmountSearch}</b>
            </span>
          </div>
          <div className="col-2">
            {this.state.tableData.length > 0 ? (
              <ExportSheet
                header={this.state.xlsxHeaders}
                dataSource={this.state.tableData}
                fileName="ExportPayments"
                isRequiredNameDate={false}
                xlsx={XLSX}
              >
                <Button
                  className="p-button-rounded p-button-success"
                  label="Export Result Excel"
                  icon="fa fa-file-excel-o"
                />
              </ExportSheet>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(Payments);
